export default "__VITE_ASSET__DFIonAP4__"